<template>
  <div class="pos-container">
    <PosHeader
      :section="section"
      :selectedFilterName="selectedFilterName"
      :onChangeFilter="onChangeFilter"
      :onClickHandler="onClickCall"
      :isLogin="false"
      :onSearchMovie="OnSearchMovie"
    />

    <section class="pos-center-view">
      <div class="row h-100">
        <div
          :class="
            section.movieDetail || fullscreen
              ? 'col-12'
              : 'col-lg-8 col-xl-9 col-md-8 col-sm-8'
          "
        >
          <!-- POS MOVIE LISTING -->
          <div v-if="section.movieDetail" class="pos-movie-listing-wrapper">
            <!-- SELECT FORMAT MODAL -->
            <b-modal
              ref="selectFormat"
              id="selectFormat"
              size="lg"
              :title="$t('Filters')"
              centered
              hide-footer
            >
              <!-- <button class="btn-modal-close" v-on:click="onCloseModal('selectFormat')">&times;</button> -->
              <h6>Formats</h6>
              <div class="row h-100 pt-2">
                <div
                  v-for="(format, formatKey) in getMovieFormats"
                  :key="formatKey"
                  v-on:click="selectedMovieFormatFilter = format.mf_id"
                  class="col-lg-3 col-md-4 col-sm-4 text-center"
                >
                  <button
                    :class="
                      `w-150 mb-3 ${
                        selectedMovieFormatFilter == format.mf_id
                          ? 'btn-blue'
                          : 'btn-outline-blue'
                      }`
                    "
                  >
                    {{ format.mf_name }}
                  </button>
                </div>
                <div
                  v-on:click="selectedMovieFormatFilter = null"
                  class="col-lg-3 col-md-4 col-sm-4 text-center"
                >
                  <button
                    :class="
                      `w-150 mb-3 ${
                        selectedMovieFormatFilter == null
                          ? 'btn-blue'
                          : 'btn-outline-blue'
                      }`
                    "
                  >
                    {{ $t("all") }}
                  </button>
                </div>
              </div>

              <h6 class="mt-3">Languages</h6>
              <div class="row h-100 pt-2">
                <div
                  v-for="(lang, LangKey) in getMovieLanguages"
                  :key="LangKey"
                  v-on:click="selectedMovieLanguageFilter = lang.lang_id"
                  class="col-lg-3 col-md-4 col-sm-4 text-center"
                >
                  <button
                    :class="
                      `w-150 mb-3 ${
                        selectedMovieLanguageFilter == lang.lang_id
                          ? 'btn-blue'
                          : 'btn-outline-blue'
                      }`
                    "
                  >
                    {{ lang.lang_name }}
                  </button>
                </div>
                <div
                  v-on:click="selectedMovieLanguageFilter = null"
                  class="col-lg-3 col-md-4 col-sm-4 text-center"
                >
                  <button
                    :class="
                      `w-150 mb-3 ${
                        selectedMovieLanguageFilter == null
                          ? 'btn-blue'
                          : 'btn-outline-blue'
                      }`
                    "
                  >
                    {{ $t("all") }}
                  </button>
                </div>
              </div>

              <h6 class="mt-3">Genre</h6>
              <div class="row h-100 pt-2">
                <div
                  v-for="(genre, genreKey) in getMovieGenres"
                  :key="genreKey"
                  v-on:click="selectedMovieGenreFilter = genre.genre_id"
                  class="col-lg-3 col-md-4 col-sm-4 text-center"
                >
                  <button
                    :class="
                      `w-150 mb-3 ${
                        selectedMovieGenreFilter == genre.genre_id
                          ? 'btn-blue'
                          : 'btn-outline-blue'
                      }`
                    "
                  >
                    {{ genre.g_name }}
                  </button>
                </div>
                <div
                  v-on:click="selectedMovieGenreFilter = null"
                  class="col-lg-3 col-md-4 col-sm-4 text-center"
                >
                  <button
                    :class="
                      `w-150 mb-3 ${
                        selectedMovieGenreFilter == null
                          ? 'btn-blue'
                          : 'btn-outline-blue'
                      }`
                    "
                  >
                    {{ $t("all") }}
                  </button>
                </div>
              </div>

              <div class="text-center">
                <button
                  class="btn-blue-lg my-3 text-center"
                  @click="applyFilters()"
                >
                  {{ $t("Apply") }}
                </button>
              </div>
            </b-modal>

            <!-- LISTED MOVIE SYNOPSIS MODAL -->
            <b-modal
              ref="movieSynopsis"
              id="listed-movie-synopsis"
              size="lg"
              centered
              modal-lg
              hide-header
              hide-footer
            >
              <div class="row" v-if="movieDetails">
                <div class="col-md-5">
                  <img
                    v-lazy="
                      getLangSpecificAttribute(
                        movieDetails.MovieContent,
                        AREA_LANG_ID,
                        'artwork_image'
                      )
                    "
                    class="img-fluid w-100 rounded-10"
                  />
                </div>
                <div class="col-md-7">
                  <div class="row mr-0">
                    <div class="col-12 border-bottom">
                      <div class="row">
                        <div class="col-md-10 d-flex align-items-center">
                          <h5 class="font-weight-bold mb-0">
                            {{
                              getLangSpecificAttribute(
                                movieDetails.MovieContent,
                                AREA_LANG_ID,
                                "mc_title"
                              ) || movieDetails.mc_title
                            }}
                          </h5>
                        </div>
                        <div class="col-md-2">
                          <button
                            class="btn-modal-close pos-modal-close"
                            v-on:click="onCloseModal('movieSynopsis')"
                          >
                            &times;
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("release") }}
                        </div>
                        <div class="col-8">
                          {{ movieDetails.mrrdr_release_date }}
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $tc("language", 1) }}
                        </div>
                        <div class="col-8">{{ movieDetails.lang_name }}</div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("rating") }}
                        </div>
                        <div class="col-8">
                          {{ movieDetails.rating }}&nbsp;&nbsp;
                          <span v-if="movieDetails.earliest_bday" class=""
                            >({{ $t("earliest_bday") }}:
                            {{ movieDetails.earliest_bday }})</span
                          >
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $tc("format", 1) }}
                        </div>
                        <div class="col-8">
                          <span>{{ movieDetails.mf_name }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("soundformat") }}
                        </div>
                        <div class="col-8">
                          <span>{{ movieDetails.sound_format_name }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("running") }} {{ $t("time") }}
                        </div>
                        <div class="col-8">
                          {{ movieDetails.mrrdr_runtime }}
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $tc("genre", 1) }}
                        </div>
                        <div class="col-8">
                          <!-- movieDetails.g_name.toString() -->
                          {{
                            movieDetails.g_name &&
                              movieDetails.g_name.join(", ")
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 py-2 border-bottom">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("castCrew") }}
                        </div>
                        <div class="col-8">
                          {{ movieDetails.movie_cast_crew }}
                        </div>
                      </div>
                    </div>

                    <div
                      class="col-12 py-2 border-bottom"
                      v-if="
                        movieDetails.movie_production &&
                          movieDetails.movie_production.length > 0
                      "
                    >
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("production") }}
                        </div>
                        <div class="col-8">
                          {{
                            movieDetails.movie_production &&
                            movieDetails.movie_production.length > 0
                              ? movieDetails.movie_production
                                  .map((x) => x.production_name)
                                  .toString()
                              : ""
                          }}
                        </div>
                      </div>
                    </div>

                    <div class="col-12 py-2">
                      <div class="row">
                        <div class="col-4 text-lightgrey">
                          {{ $t("synopsis") }}
                        </div>
                        <div class="col-8">
                          {{
                            getLangSpecificAttribute(
                              movieDetails.MovieContent,
                              AREA_LANG_ID,
                              "mc_plot"
                            )
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 py-2 text-center fs-12">
                  <p class="text-muted">
                    {{ $t("showing_content_in_language") }}:
                    <b-dropdown
                      right
                      variant="pos-dropdown"
                      class="mr-3 al_dropdown"
                    >
                      <template v-slot:button-content class="text-primary">
                        <img
                          src="@/assets/img/icons/language-icon.svg"
                          height="25px"
                          width="25px"
                        />
                        <span class="text-primary">{{
                          selectedContentLang.lang_name
                        }}</span>
                      </template>
                      <div>
                        <b-dropdown-item
                          v-for="(lang, langIndex) in movieDetails.MovieContent"
                          :key="langIndex"
                          @click="onChangeAreaLanguage(lang)"
                          >{{ lang.lang_name }}</b-dropdown-item
                        >
                      </div>
                    </b-dropdown>
                  </p>
                </div>
              </div>
            </b-modal>

            <div class="pos_movie_search_n_filters">
              <!--Down Filter---->
              <div class="d-flex align-items-center">
                <PosDateSlider
                  :onChangeTab="OnChangeDate"
                  :selectedTabIndex="selectedTabIndex"
                  :dateSelectionSlider="silderOne"
                  :childComponents="childComponents"
                  :customClass="'width97'"
                />

                <button
                  @click="toggleCalendar(true)"
                  class="btn-date btn-transparent"
                  style="margin-bottom: 20px"
                >
                  <img src="@/assets/img/icons/claendar.svg" />
                </button>
              </div>

              <section class="pos_movie_search_n_filters__content">
                <!-- if movie -->
                <div v-if="selectedFilterName === 'movie'">
                  <div v-if="isDataLoading" class="pos-no-schedule">
                    <div class="text-center">
                      <div>
                        <img
                          src="@/assets/img/icons/loading.svg"
                          height="75"
                          width="75"
                        />
                      </div>
                      <br />
                      <h6>Fetching Shows...Please Wait</h6>
                    </div>
                  </div>

                  <div
                    v-if="!isDataLoading && visibleShowsDates.length == 0"
                    class="pos-no-schedule"
                  >
                    <div class="text-center">
                      <div>
                        <img
                          src="@/assets/img/icons/no-schedule.svg"
                          height="75"
                          width="75"
                        />
                      </div>
                      <br />
                      <h6>No shows are scheduled for this date.</h6>
                    </div>
                  </div>

                  <div
                    class="movie-tab-wrapper movie-list"
                    v-if="visibleShowsDates.length > 0"
                  >
                    <template v-if="stylev2">
                      <div class="movie-list-single">
                        <div class="row">
                          <div
                            class="col-12 p-2"
                            v-for="(shows, showsKey) in visibleShowsDates"
                            :key="showsKey"
                          >
                            <div class="movie-card-horizontal-single">
                              <div class="poster">
                                <img
                                  v-b-modal.listed-movie-synopsis
                                  v-on:click="
                                    onClickMovieModal(
                                      shows[0].movie_id,
                                      shows[0].md_id
                                    )
                                  "
                                  v-lazy="
                                    getLangSpecificAttribute(
                                      shows[0].altMovieContent,
                                      shows[0].lang_id,
                                      'artwork'
                                    )
                                  "
                                  alt="Son Of Sardar 2"
                                />
                              </div>
                              <div class="details">
                                <h3 class="title">
                                  {{ shows[0].movie_title }}
                                </h3>
                                <div class="meta">
                                  <span>{{
                                    shows[0].lang_version ||
                                      shows[0].language_name
                                  }}</span>
                                  <span
                                    class="movie-format mr-1 formatBox"
                                    v-if="shows[0].movie_format"
                                    >{{ shows[0].movie_format }}
                                  </span>
                                  <span
                                    v-if="shows[0].sound_format_name"
                                    class="movie-format formatBox"
                                  >
                                    {{ shows[0].sound_format_name }}</span
                                  >
                                  <span
                                    v-if="shows[0].movie_experience"
                                    class="formatBox"
                                    >{{ shows[0].movie_experience }}</span
                                  >
                                  <span v-else></span>
                                  <span class="badge">{{
                                    shows[0].rating
                                  }}</span>
                                  <span class="duration"
                                    >{{ shows[0].mrrdr_runtime }} Min</span
                                  >
                                </div>
                                <div>
                                  <ul class="listed-movie-time-list">
                                    <li
                                      v-for="(singleShow,
                                      singleShowIndex) in getSortArrayHere(
                                        shows
                                      )"
                                      v-on:click="
                                        onClickShow(
                                          shows[singleShowIndex],
                                          singleShow,
                                          getSortArrayHere(shows)
                                        )
                                      "
                                      :key="singleShowIndex"
                                      :class="
                                        allowPastBooking == 'Y'
                                          ? 'cursor-pointer available-button'
                                          : singleShow.is_private_event == 'Y' ? 'private_event_btn' : !timeSinceShowElapsed(
                                              singleShow.ss_start_show_time,
                                              singleShow.ss_actual_start_date,
                                              singleShow.cine_cutoff_time_in_mins
                                            )
                                          ? 'disabled'
                                          : singleShow.percentage_by_movie < 60
                                          ? 'cursor-pointer available-button'
                                          : singleShow.percentage_by_movie >=
                                              60 &&
                                            singleShow.percentage_by_movie <= 99
                                          ? 'cursor-pointer filling-fast-button'
                                          : singleShow.percentage_by_movie ==
                                            100
                                          ? 'house-full-button disabled'
                                          : ''
                                      "
                                    >
                                      {{
                                        moment(
                                          singleShow.ss_start_show_time,
                                          "HH:mm"
                                        ).format(TIME_FORMAT)
                                      }}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>

                    <div class="row" id="movie-list-visibleShowsDates" v-else>
                      <div
                        class="col-12 col-lg-12 col-md-12 col-sm-12"
                        v-for="(shows, showKey) in visibleShowsDates"
                        :key="showKey"
                      >
                        <div class="row">
                          <div
                            class="col-lg-2 col-xl-2 col-md-2 col-sm-2 cursor-pointer"
                          >
                            <div class="img-hover">
                              <img
                                v-b-modal.listed-movie-synopsis
                                v-on:click="
                                  onClickMovieModal(
                                    shows[0].movie_id,
                                    shows[0].md_id
                                  )
                                "
                                v-lazy="
                                  getLangSpecificAttribute(
                                    shows[0].altMovieContent,
                                    shows[0].lang_id,
                                    'artwork'
                                  )
                                "
                                class="rounded-10 img_height"
                              /><!--style="height:22vh;"-->
                            </div>
                          </div>
                          <div
                            class="col-sm-10 col-md-10 col-lg-10 col-xl-10 pl-0 pr-4"
                          >
                            <div class="w-100 pl-3 pt-3 bg-white rounded-10">
                              <!--h-100-->
                              <div class="d-flex align-items-center mb-lg-2">
                                <div class="mr-4 movie-name">
                                  {{ shows[0].movie_title }}
                                </div>
                                <span class="movie-rating">{{
                                  shows[0].rating
                                }}</span>
                              </div>

                              <div class="mb-lg-2">
                                <span class="mr-2">{{
                                  shows[0].lang_version ||
                                    shows[0].language_name
                                }}</span>
                                <span
                                  class="movie-format"
                                  v-if="shows[0].movie_format"
                                  >{{ shows[0].movie_format }}</span
                                >
                                &nbsp;
                                <span class="movie-runtime"
                                  >{{ shows[0].mrrdr_runtime }} Min</span
                                >
                              </div>

                              <div class="mr-3">
                                <ul class="listed-movie-time-list rounded">
                                  <li
                                    v-for="(singleShow,
                                    singleShowIndex) in getSortArrayHere(shows)"
                                    v-on:click="
                                      onClickShow(
                                        shows[singleShowIndex],
                                        singleShow,
                                        getSortArrayHere(shows)
                                      )
                                    "
                                    :key="singleShowIndex"
                                    :class="
                                      allowPastBooking == 'Y'
                                        ? 'cursor-pointer available-button'
                                        : singleShow.is_private_event == 'Y' ? 'private_event_btn' : !timeSinceShowElapsed(
                                            singleShow.ss_start_show_time,
                                            singleShow.ss_actual_start_date,
                                            singleShow.cine_cutoff_time_in_mins
                                          )
                                        ? 'disabled'
                                        : singleShow.percentage_by_movie < 60
                                        ? 'cursor-pointer available-button'
                                        : singleShow.percentage_by_movie >=
                                            60 &&
                                          singleShow.percentage_by_movie <= 99
                                        ? 'cursor-pointer filling-fast-button'
                                        : singleShow.percentage_by_movie == 100
                                        ? 'house-full-button disabled'
                                        : ''
                                    "
                                  >
                                    {{
                                      moment(
                                        singleShow.ss_start_show_time,
                                        "HH:mm:ss"
                                      ).format(TIME_FORMAT)
                                    }}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="movie-card-seperator"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- if date -->
                <div v-if="selectedFilterName === 'date'">
                  <div
                    v-if="visibleShowsDates.length === 0"
                    class="pos-no-schedule"
                  >
                    <div class="text-center">
                      <div>
                        <img
                          src="@/assets/img/icons/no-schedule.svg"
                          height="75"
                          width="75"
                        />
                      </div>
                      <br />
                      <h6>No shows are scheduled for this date.</h6>
                    </div>
                  </div>

                  <template v-else>
                    <template v-if="stylev2">
                      <div class="row movie-list">
                        <div
                          class="col-xl-4 col-lg-4 col-sm-6 col-xs-12 p-2"
                          v-for="(shows, showsKey) in visibleShowsDates"
                          :key="showsKey"
                        >
                          <div class="movie-card-horizontal">
                            <div class="poster">
                              <img
                                v-b-modal.listed-movie-synopsis
                                v-on:click="
                                  onClickMovieModal(
                                    shows[0].movie_id,
                                    shows[0].md_id
                                  )
                                "
                                v-lazy="
                                  getLangSpecificAttribute(
                                    shows[0].altMovieContent,
                                    shows[0].lang_id,
                                    'artwork'
                                  )
                                "
                                alt="Son Of Sardar 2"
                              />
                            </div>
                            <div class="details">
                              <h3 class="title">{{ shows[0].movie_title }}</h3>
                              <div class="meta">
                                <span>{{
                                  shows[0].lang_version ||
                                    shows[0].language_name
                                }}</span>
                                <span
                                  class="movie-format mr-1 formatBox"
                                  v-if="shows[0].movie_format"
                                  >{{ shows[0].movie_format }}
                                </span>
                                <span
                                  v-if="shows[0].sound_format_name"
                                  class="movie-format formatBox"
                                >
                                  {{ shows[0].sound_format_name }}</span
                                >
                                <span
                                  v-if="shows[0].movie_experience"
                                  class="formatBox"
                                  >{{ shows[0].movie_experience }}</span
                                >
                                <span v-else></span>
                                <span class="badge">{{ shows[0].rating }}</span>
                                <!-- <span class="duration"
                                >{{ shows[0].mrrdr_runtime }} Min</span
                              > -->
                              </div>
                              <div class="duration">
                                {{ shows[0].mrrdr_runtime }} Min
                              </div>
                              <div>
                                <ul class="listed-movie-time-list">
                                  <li
                                    v-for="(singleShow,
                                    singleShowIndex) in getSortArrayHere(shows)"
                                    v-on:click="
                                      onClickShow(
                                        shows[singleShowIndex],
                                        singleShow,
                                        getSortArrayHere(shows)
                                      )
                                    "
                                    :key="singleShowIndex"
                                    :class="
                                      allowPastBooking == 'Y'
                                        ? 'cursor-pointer available-button'
                                        : singleShow.is_private_event == 'Y' ? 'private_event_btn' : !timeSinceShowElapsed(
                                            singleShow.ss_start_show_time,
                                            singleShow.ss_actual_start_date,
                                            singleShow.cine_cutoff_time_in_mins
                                          )
                                        ? 'disabled'
                                        : singleShow.percentage_by_movie < 60
                                        ? 'cursor-pointer available-button'
                                        : singleShow.percentage_by_movie >=
                                            60 &&
                                          singleShow.percentage_by_movie <= 99
                                        ? 'cursor-pointer filling-fast-button'
                                        : singleShow.percentage_by_movie == 100
                                        ? 'house-full-button disabled'
                                        : ''
                                    "
                                  >
                                    {{
                                      moment(
                                        singleShow.ss_start_show_time,
                                        "HH:mm"
                                      ).format(TIME_FORMAT)
                                    }}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="movie-selection-container">
                        <div
                          class="movie-listing-card col-2"
                          v-for="(shows, showsKey) in visibleShowsDates"
                          :key="showsKey"
                        >
                          <div class="movie-listing-card-content" v-if="shows">
                            <!-- <div v-b-modal.listed-movie-synopsis> -->
                            <div
                              class="listed-movie-detail-wrapper cursor-pointer img-hover"
                            >
                              <img
                                v-b-modal.listed-movie-synopsis
                                v-on:click="
                                  onClickMovieModal(
                                    shows[0].movie_id,
                                    shows[0].md_id
                                  )
                                "
                                v-lazy="
                                  getLangSpecificAttribute(
                                    shows[0].altMovieContent,
                                    shows[0].lang_id,
                                    'artwork'
                                  )
                                "
                                class="img-fluid w-100"
                                style="height: 24vh"
                              />
                              <div class="listed-movie-details 123">
                                <div class="d-flex">
                                  <div class="w-75">
                                    <div class="movie-name">
                                      {{ shows[0].movie_title }}
                                    </div>
                                  </div>
                                  <div class="w-25 text-right">
                                    <span class="movie-rating">{{
                                      shows[0].rating
                                    }}</span>
                                  </div>
                                </div>

                                <div class="d-flex justify-content-evenly">
                                  <div
                                    class="w-100 mb-1 d-flex justify-content-between"
                                  >
                                    <div>
                                      <span class="mr-1">{{
                                        shows[0].lang_version ||
                                          shows[0].language_name
                                      }}</span>
                                      <span
                                        class="movie-format mr-1"
                                        v-if="shows[0].movie_format"
                                        >{{ shows[0].movie_format }}
                                      </span>
                                      <span
                                        v-if="shows[0].sound_format_name"
                                        class="movie-format"
                                      >
                                        {{ shows[0].sound_format_name }}</span
                                      >
                                      <span v-if="shows[0].movie_experience">{{
                                        shows[0].movie_experience
                                      }}</span>
                                      <span v-else></span>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                      <div
                                        class="text-blue ml-1"
                                        style="width: 45px; white-space: nowrap"
                                      >
                                        {{ shows[0].mrrdr_runtime }} Min
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="ml-1"></div>
                                <div>
                                  <ul class="listed-movie-time-list">
                                    <li
                                      v-for="(singleShow,
                                      singleShowIndex) in getSortArrayHere(
                                        shows
                                      )"
                                      v-on:click="
                                        onClickShow(
                                          shows[singleShowIndex],
                                          singleShow,
                                          getSortArrayHere(shows)
                                        )
                                      "
                                      :key="singleShowIndex"
                                      :class="
                                        allowPastBooking == 'Y'
                                          ? 'cursor-pointer available-button'
                                          : singleShow.is_private_event == 'Y' ? 'private_event_btn' : !timeSinceShowElapsed(
                                              singleShow.ss_start_show_time,
                                              singleShow.ss_actual_start_date,
                                              singleShow.cine_cutoff_time_in_mins
                                            )
                                          ? 'disabled'
                                          : singleShow.percentage_by_movie < 60
                                          ? 'cursor-pointer available-button'
                                          : singleShow.percentage_by_movie >=
                                              60 &&
                                            singleShow.percentage_by_movie <= 99
                                          ? 'cursor-pointer filling-fast-button'
                                          : singleShow.percentage_by_movie ==
                                            100
                                          ? 'house-full-button disabled'
                                          : ''
                                      "
                                    >
                                      {{
                                        moment(
                                          singleShow.ss_start_show_time,
                                          "HH:mm"
                                        ).format(TIME_FORMAT)
                                      }}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <!-- </div> -->
                          </div>

                          <!-- SHOW TIMING LIST -->
                        </div>
                      </div>
                    </template>
                  </template>
                </div>

                <!-- tab three -->

                <!-- if screen -->
                <div v-if="selectedFilterName === 'screen'">
                  <div
                    v-if="visibleShowsScreens.length == 0"
                    class="pos-no-schedule"
                  >
                    <div class="text-center">
                      <div>
                        <img
                          src="@/assets/img/icons/no-schedule.svg"
                          height="75"
                          width="75"
                        />
                      </div>
                      <br />
                      <h6>No shows are scheduled for this date.</h6>
                    </div>
                  </div>

                  <div class="screen-tab-wrapper movie-list" v-else>
                    <div
                      class="w-100"
                      v-for="(screenShow, screenShowKey) in visibleShowsScreens"
                      :key="screenShowKey"
                    >
                      <h6 class="font-weight-bold" style="font-size: 18px">
                        {{ screenShow[0][0].screen_name }}
                      </h6>
                      <div class="row mx-0">
                        <template v-if="stylev2">
                          <div
                            class="col-xl-4 col-lg-4 col-sm-6 col-xs-12 p-2"
                            v-for="(movie, movieKey) in screenShow"
                            :key="movieKey"
                          >
                            <div class="movie-card-horizontal">
                              <div class="poster">
                                <img
                                  v-b-modal.listed-movie-synopsis
                                  v-on:click="
                                    onClickMovieModal(
                                      movie[0].movie_id,
                                      movie[0].md_id
                                    )
                                  "
                                  v-lazy="
                                    getLangSpecificAttribute(
                                      movie[0].altMovieContent,
                                      movie[0].lang_id,
                                      'artwork'
                                    )
                                  "
                                  alt="Son Of Sardar 2"
                                />
                              </div>
                              <div class="details">
                                <h3 class="title">
                                  {{ movie[0].movie_title }}
                                </h3>
                                <div class="meta">
                                  <span>{{
                                    movie[0].lang_version ||
                                      movie[0].language_name
                                  }}</span>
                                  <span
                                    class="movie-format mr-1 formatBox"
                                    v-if="movie[0].movie_format"
                                    >{{ movie[0].movie_format }}
                                  </span>
                                  <span
                                    v-if="movie[0].sound_format_name"
                                    class="movie-format formatBox"
                                  >
                                    {{ movie[0].sound_format_name }}</span
                                  >
                                  <span
                                    v-if="movie[0].movie_experience"
                                    class="formatBox"
                                    >{{ movie[0].movie_experience }}</span
                                  >
                                  <span v-else></span>
                                  <span class="badge">{{
                                    movie[0].rating
                                  }}</span>
                                  <span class="duration"
                                    >{{ movie[0].mrrdr_runtime }} Min</span
                                  >
                                </div>
                                <div class="text-blue">
                                  {{ movie[0].screen_name }}
                                </div>
                                <div>
                                  <ul class="listed-movie-time-list">
                                    <li
                                      v-for="(showTime, showTimeKey) in movie"
                                      :key="showTimeKey"
                                      v-on:click="
                                        onClickShow(
                                          movie[showTimeKey],
                                          showTime,
                                          movie
                                        )
                                      "
                                      :class="
                                        allowPastBooking == 'Y'
                                          ? 'cursor-pointer available-button'
                                          : showTime.is_private_event == 'Y' ? 'private_event_btn' : !timeSinceShowElapsed(
                                              showTime.ss_start_show_time,
                                              showTime.ss_actual_start_date,
                                              showTime.cine_cutoff_time_in_mins
                                            )
                                          ? 'disabled'
                                          : showTime.percentage_by_movie < 60
                                          ? 'cursor-pointer available-button'
                                          : showTime.percentage_by_movie >=
                                              60 &&
                                            showTime.percentage_by_movie <= 99
                                          ? 'cursor-pointer filling-fast-button'
                                          : showTime.percentage_by_movie == 100
                                          ? 'house-full-button disabled'
                                          : ''
                                      "
                                    >
                                      {{
                                        moment(
                                          showTime.ss_start_show_time,
                                          "HH:mm"
                                        ).format(TIME_FORMAT)
                                      }}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div
                            class="movie-listing-card mb-4 cursor-pointer col-2"
                            v-for="(movie, movieKey) in screenShow"
                            :key="movieKey"
                          >
                            <div class="movie-listing-card-content">
                              <div
                                class="listed-movie-detail-wrapper img-hover"
                              >
                                <img
                                  v-b-modal.listed-movie-synopsis
                                  v-on:click="
                                    onClickMovieModal(
                                      movie[0].movie_id,
                                      movie[0].md_id
                                    )
                                  "
                                  v-lazy="
                                    getLangSpecificAttribute(
                                      movie[0].altMovieContent,
                                      movie[0].lang_id,
                                      'artwork'
                                    )
                                  "
                                  class="img-fluid"
                                  style="height: 24vh"
                                />
                                <!-- <img src="@/assets/img/pos/pos-test-3.jpg" class="img-fluid" /> -->
                                <div
                                  class="listed-movie-details 456"
                                  style="border-radius: 0px"
                                >
                                  <div class="d-flex">
                                    <div class="w-75">
                                      <div class="movie-name">
                                        {{ movie[0].movie_title }}
                                      </div>
                                    </div>
                                    <div class="w-25 text-right">
                                      <span class="movie-rating">{{
                                        movie[0].rating
                                      }}</span>
                                    </div>
                                  </div>

                                  <div class="d-flex flex-wrap">
                                    <div class="w-100 mb-1">
                                      <span class="mr-1">{{
                                        movie[0].lang_version ||
                                          movie[0].language_name
                                      }}</span>
                                      <span
                                        class="movie-format"
                                        v-if="movie[0].movie_format"
                                        >{{ movie[0].movie_format }}</span
                                      >
                                    </div>
                                    <div
                                      class="d-flex justify-content-between w-100"
                                    >
                                      <div class="text-blue">
                                        {{ movie[0].screen_name }}
                                      </div>
                                      <div class="text-blue">
                                        {{ movie[0].mrrdr_runtime }} Min
                                      </div>
                                    </div>
                                  </div>
                                  <div>
                                    <ul class="listed-movie-time-list">
                                      <li
                                        v-for="(showTime, showTimeKey) in movie"
                                        :key="showTimeKey"
                                        v-on:click="
                                          onClickShow(
                                            movie[showTimeKey],
                                            showTime,
                                            movie
                                          )
                                        "
                                        :class="
                                          allowPastBooking == 'Y'
                                            ? 'cursor-pointer available-button'
                                            : showTime.is_private_event == 'Y' ? 'private_event_btn' : !timeSinceShowElapsed(
                                                showTime.ss_start_show_time,
                                                showTime.ss_actual_start_date,
                                                showTime.cine_cutoff_time_in_mins
                                              )
                                            ? 'disabled'
                                            : showTime.percentage_by_movie < 60
                                            ? 'cursor-pointer available-button'
                                            : showTime.percentage_by_movie >=
                                                60 &&
                                              showTime.percentage_by_movie <= 99
                                            ? 'cursor-pointer filling-fast-button'
                                            : showTime.percentage_by_movie ==
                                              100
                                            ? 'house-full-button disabled'
                                            : ''
                                        "
                                      >
                                        {{
                                          moment(
                                            showTime.ss_start_show_time,
                                            "HH:mm"
                                          ).format(TIME_FORMAT)
                                        }}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- SHOW TIMING LIST -->
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- tab four -->

                <!-- if language -->
                <div v-if="selectedFilterName === 'language'">
                  <div
                    v-if="visibleShowsLanguage.length == 0"
                    class="pos-no-schedule"
                  >
                    <div class="text-center">
                      <div>
                        <img
                          src="@/assets/img/icons/no-schedule.svg"
                          height="75"
                          width="75"
                        />
                      </div>
                      <br />
                      <h6>No shows are scheduled for this date.</h6>
                    </div>
                  </div>

                  <div class="language-tab-wrapper movie-list" v-else>
                    <div
                      class="w-100"
                      v-for="(lang, langKey) in visibleShowsLanguage"
                      :key="langKey"
                    >
                      <h6 class="font-weight-bold" style="font-size: 18px">
                        {{ lang[0][0].language_name }}
                      </h6>

                      <div class="row mx-0">
                        <template v-if="stylev2">
                          <div
                            class="col-xl-4 col-lg-4 col-sm-6 col-xs-12 p-2"
                            v-for="(movie, movieKey) in lang"
                            :key="movieKey"
                          >
                            <div class="movie-card-horizontal">
                              <div class="poster">
                                <img
                                  v-b-modal.listed-movie-synopsis
                                  v-on:click="
                                    onClickMovieModal(
                                      movie[0].movie_id,
                                      movie[0].md_id
                                    )
                                  "
                                  v-lazy="
                                    getLangSpecificAttribute(
                                      movie[0].altMovieContent,
                                      movie[0].lang_id,
                                      'artwork'
                                    )
                                  "
                                  alt="Son Of Sardar 2"
                                />
                              </div>
                              <div class="details">
                                <h3 class="title">
                                  {{ movie[0].movie_title }}
                                </h3>
                                <div class="meta">
                                  <span>{{
                                    movie[0].lang_version ||
                                      movie[0].language_name
                                  }}</span>
                                  <span
                                    class="movie-format mr-1 formatBox"
                                    v-if="movie[0].movie_format"
                                    >{{ movie[0].movie_format }}
                                  </span>
                                  <span
                                    v-if="movie[0].sound_format_name"
                                    class="movie-format formatBox"
                                  >
                                    {{ movie[0].sound_format_name }}</span
                                  >
                                  <span
                                    v-if="movie[0].movie_experience"
                                    class="formatBox"
                                    >{{ movie[0].movie_experience }}</span
                                  >
                                  <span v-else></span>
                                  <span class="badge">{{
                                    movie[0].rating
                                  }}</span>
                                  <!-- <span class="duration"
                                    >{{ movie[0].mrrdr_runtime }} Min</span
                                  > -->
                                </div>
                                <div class="duration">
                                  {{ movie[0].mrrdr_runtime }} Min
                                </div>
                                <div class="text-blue">
                                  {{ movie[0].screen_name }}
                                </div>
                                <div>
                                  <ul class="listed-movie-time-list">
                                    <li
                                      v-for="(showTime, showTimeKey) in movie"
                                      :key="showTimeKey"
                                      v-on:click="
                                        onClickShow(
                                          movie[showTimeKey],
                                          showTime,
                                          movie
                                        )
                                      "
                                      :class="
                                        allowPastBooking == 'Y'
                                          ? 'cursor-pointer available-button'
                                          : showTime.is_private_event == 'Y' ? 'private_event_btn' : !timeSinceShowElapsed(
                                              showTime.ss_start_show_time,
                                              showTime.ss_actual_start_date,
                                              showTime.cine_cutoff_time_in_mins
                                            )
                                          ? 'disabled'
                                          : showTime.percentage_by_movie < 60
                                          ? 'cursor-pointer available-button'
                                          : showTime.percentage_by_movie >=
                                              60 &&
                                            showTime.percentage_by_movie <= 99
                                          ? 'cursor-pointer filling-fast-button'
                                          : showTime.percentage_by_movie == 100
                                          ? 'house-full-button disabled'
                                          : ''
                                      "
                                    >
                                      {{
                                        moment(
                                          showTime.ss_start_show_time,
                                          "HH:mm"
                                        ).format(TIME_FORMAT)
                                      }}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div
                            v-b-modal.listed-movie-synopsis
                            class="movie-listing-card mb-4 cursor-pointer col-2"
                            v-for="(movie, movieKey) in lang"
                            :key="movieKey"
                          >
                            <div class="movie-listing-card-content">
                              <div
                                class="listed-movie-detail-wrapper img-hover"
                              >
                                <img
                                  v-b-modal.listed-movie-synopsis
                                  v-on:click="
                                    onClickMovieModal(
                                      movie[0].movie_id,
                                      movie[0].md_id
                                    )
                                  "
                                  v-lazy="
                                    getLangSpecificAttribute(
                                      movie[0].altMovieContent,
                                      movie[0].lang_id,
                                      'artwork'
                                    )
                                  "
                                  class="img-fluid"
                                  style="height: 24vh"
                                />
                                <div
                                  class="listed-movie-details 789"
                                  style="border-radius: 0px"
                                >
                                  <div class="d-flex">
                                    <div class="w-75">
                                      <div class="movie-name">
                                        {{ movie[0].movie_title }}
                                      </div>
                                    </div>
                                    <div class="w-25 text-right">
                                      <span class="movie-rating">{{
                                        movie[0].rating
                                      }}</span>
                                    </div>
                                  </div>

                                  <div class="d-flex flex-wrap">
                                    <div class="w-100 mb-1">
                                      <span class="mr-1">{{
                                        movie[0].lang_version ||
                                          movie[0].language_name
                                      }}</span>
                                      <span
                                        class="movie-format"
                                        v-if="movie[0].movie_format"
                                        >{{ movie[0].movie_format }}</span
                                      >
                                    </div>
                                    <div
                                      class="d-flex justify-content-between w-100"
                                    >
                                      <!-- <div class="text-blue">
                                    {{ movie[0].screen_name?movie[0].screen_name:"-" }}
                                  </div> -->
                                      <div class="text-blue">
                                        {{ movie[0].mrrdr_runtime }} Min
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <ul class="listed-movie-time-list">
                                <li
                                  v-for="(showTime, showTimeKey) in movie"
                                  :key="showTimeKey"
                                  v-on:click="
                                    onClickShow(
                                      movie[showTimeKey],
                                      showTime,
                                      movie
                                    )
                                  "
                                  :class="
                                    allowPastBooking == 'Y'
                                      ? 'cursor-pointer available-button'
                                      : showTime.is_private_event == 'Y' ? 'private_event_btn' : !timeSinceShowElapsed(
                                          showTime.ss_start_show_time,
                                          showTime.ss_actual_start_date,
                                          showTime.cine_cutoff_time_in_mins
                                        )
                                      ? 'disabled'
                                      : showTime.percentage_by_movie < 60
                                      ? 'cursor-pointer available-button'
                                      : showTime.percentage_by_movie >= 60 &&
                                        showTime.percentage_by_movie <= 99
                                      ? 'cursor-pointer filling-fast-button'
                                      : showTime.percentage_by_movie == 100
                                      ? 'house-full-button disabled'
                                      : ''
                                  "
                                >
                                  {{
                                    moment(
                                      showTime.ss_start_show_time,
                                      "HH:mm"
                                    ).format(TIME_FORMAT)
                                  }}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <!-- RIGHT DETAIL PANELS -->
      </div>
    </section>

    <div class="pos-datepicker-container" v-if="datePickerContainer">
      <div class="pos-datepicker">
        <Datepicker
          :monday-first="true"
          ref="programaticOpen"
          v-model="selectedCalDate"
          :inline="true"
        ></Datepicker>
        <button class="btn-modal-close" v-on:click="toggleCalendar(false)">
          &times;
        </button>
        <button class="btn-blue-lg w-100 mt-4" v-on:click="submitDate()">
          {{ $t("done") }}
        </button>
      </div>
    </div>

    <PosFooter
      v-if="!fullscreen"
      ref="posFooterComponent"
      :section="section"
      :enableClass="removeClass"
      :onClickHandler="onClickCall"
    />

    <ManagerAuthLogin
      :moduleName="'posOfferAuth_pos_booking'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'posOfferAuth_pos_booking'"
    />
    <ManagerAuthLogin
      :moduleName="'privateEventAuth'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'privateEventAuth'"
    />
  </div>
</template>

<script>
  import Slick from "vue-slick";
  import PosHeader from "@/components/Partials/posHeader.vue";
  import PosFooter from "@/components/Partials/posFooter.vue";
  import { BASEURL } from "@/config/index.js";
  import moment from "moment";
  import momentTimeZone from "moment-timezone";
  import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
  import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
  import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
  import PosService from "@/services/PosService.js";
  import PosDateSlider from "@/components/Partials/posDateSlider.vue";
  import _, { groupBy } from "lodash";
  import { encryptString } from "@/helper/collection";
  import { CLIENT_NAMES_OBJ, CLIENT_NAME } from "@/helper/Role";

  export default {
    components: {
      Slick,
      PosHeader,
      PosFooter,
      PosDateSlider,
      VkeyboardFloat,
      Vkeyboard,
      ManagerAuthLogin,
    },
    data() {
      return {
        noAuth: false,
        tempSelectedShowTime: {
          params1: null,
          params2: null
        },
        showResponse: null,
        selectedContentLang: {
          lang_id: null,
          lang_name: "",
        },
        selectedCalDate: new Date(),
        datePickerContainer: false,
        getMovieFormats: [],
        getMovieLanguages: [],
        getMovieGenres: [],
        movieDetails: {},
        CONTENT_LANG_ARRAY: [],
        visibleShowsDates: [],
        visibleShowsScreens: [],
        visibleShowsLanguage: [],
        URL_BASE: BASEURL,
        isDataLoading: false,
        removeClass: true,
        silderOne: {
          infinite: false,
          dots: false,
          arrows: true,
          slidesToShow: 5,
        },
        childComponents: {
          PosRefund: false,
          FnbRefund: false,
          Swap: false,
          PosSchedule: false,
          PosOccupancyStatus: false,
          PosFinalTicket: false,
          PosCustomerLoyaltyPoints: false,
          PosPackageFinalTicket: false,
          UnpaidBooking: false,
          posUserCollection: false,
          posUserTransaction: false,
          posUserFnbTransaction: false,
          cashCard: false,
          CashCardFinalPage: false,
          getDatesArray: [],
          SELECTED_DATE: "",
        },
        section: {
          movieDetail: true,
          seatLayout: false,
          checkout: false,
          cashCardTopup: false,
          eWalletTopup: false,
        },
        sectionHistory: ["movieDetail"],
        cinema_config: {},
        search: "",

        selectedTabIndex: 0,
        selectedFilterName: "date",
        fullscreen: false,
        Formats: [],
        selectedMovieLanguageFilter: null,
        selectedMovieFormatFilter: null,
        selectedMovieGenreFilter: null,
        selected_ssid: null,
        disableCreditPayBtn: false,
      };
    },
    watch: {},
    beforeDestroy() {},
    destroyed() {},
    beforeMount() {
      this.GET_CACHE_KEY();
    },
    updated() {},
    created() {},
    destroyed: function() {},
    mounted() {
      this.GET_DATES();
      setTimeout(() => {
        if (this.$socket) {
          this.$socket.emit("home_page");
          this.$socket.emit("set_org_details", this.getOrganizationDetails);
        }
      }, 2000);
    },
    computed: {
      // POS OFFERS SAIF END
      AREA_LANG_ID() {
        //return this.$store.getters.AREA_LANG_ID;
        return this.selectedContentLang["lang_id"];
      },
      allowPastBooking() {
        return this.$store.getters.getPastBooking;
      },
      getOrganizationDetails() {
        return this.$store.getters.getOrganizationDetails;
      },
      stylev2() {
        // return CLIENT_NAMES_OBJ.platinum.includes(this.CLIENT_SETUP_NAME);
        return true;
      },
    },
    methods: {
      moment,
      momentTimeZone,
      toggleCalendar(status) {
        this.datePickerContainer = status;
      },
      onChangeAreaLanguage(lang) {
        this.selectedContentLang = {
          lang_id: lang.lang_id,
          lang_name: lang.lang_name,
        };
        this.$forceUpdate();
      },
      submitDate() {
        this.childComponents.SELECTED_DATE = moment(
          new Date(this.selectedCalDate)
        ).format("DD-MM-YYYY");
        this.childComponents["isSlideSlick"] = true;
        this.datePickerContainer = false;
        this.GET_SHOWS();
      },
      onClickShow(showTime, showTimeN, allShowTimes) {
        if (showTime.is_private_event == 'Y' && !this.noAuth) {
          this.$toasted.show("Private Event - Authentication Required.")
          this.tempSelectedShowTime['params1'] = showTime;
          this.tempSelectedShowTime['params2'] = allShowTimes;
          return this.$bvModal.show("privateEventAuth")
        }

        this.sendAuditLogs({
          action: `SELECTED MOVIE-${showTime.movie_title}, SCREEN-${
            showTime.screen_name
          }, DATE-${moment(showTime.ss_start_date).format("DD-MM-YYYY")} ${
            showTime.ss_start_show_time
          }, SCHEDULE ID-${showTime.ss_id}`,
          page_name: "POS MOVIE LIST PAGE",
          api_name: window.location.hash,
        });

        let tempArray = [];
        if (allShowTimes && allShowTimes.length > 0) {
          allShowTimes.forEach((show_t) => {
            let tempObj = {
              ss_id: null,
              ss_actual_start_date: null,
              ss_actual_start_date_time: null,
              movie_details_id: null,
              screen_id: null,
              cine_id: null,
              cine_cutoff_time_in_mins: null,
              screen_name: "",
              movie_id: null,
              md_id: null,
              movie_title: "",
              ss_start_show_time: null,
              ss_end_show_time: null,
              ss_start_date: null,
              ss_end_date: null,
              ss_start_date_time: null,
              percentage_by_movie: 0,
            };

            Object.keys(tempObj).map((key) => {
              tempObj[key] = show_t[key] || tempObj[key];
            });
            tempArray.push(tempObj);
          });
        }

        let encryptedObj = encryptString(JSON.stringify(tempArray));
        this.$router.push({
          path: `/pos-seatlayout/${showTime.ss_id}/${showTime.md_id}/${showTime.screen_id}`,
          query: {
            STA: encryptedObj || ``,
          },
        });
      },
      OnSearchMovie(event) {
        console.log(event);
        this.search = event;
        // this.GET_SHOWS();
        this.searchMovieOffline();
      },
      fetchMovieLanguages() {
        PosService.getMovieLanguages()
          .then((resp) => {
            const { data } = resp;
            if (data.status) {
              this.getMovieLanguages = data.Records.filter((z) => {
                return z.lang_name;
              });
            }
          })
          .catch((err) => console.log("err when fetching languages: ", err));
      },
      fetchMovieGenre() {
        PosService.getMovieGenre()
          .then((resp) => {
            const { data } = resp;
            if (data.status) {
              this.getMovieGenres = data.Records;
            }
          })
          .catch((err) => console.log("err when fetching languages: ", err));
      },
      fetchMovieFormats() {
        PosService.getMovieFormats()
          .then((resp) => {
            const { data } = resp;
            if (data.status) {
              this.getMovieFormats = data.Records;
            }
          })
          .catch((err) => console.log("error when fetching formats: ", err));
      },
      GET_DATES() {
        console.log("cacheModePos", this.cacheModePos);
        let datesArray = window.localStorage.getItem("datesArray");
        if (datesArray && this.cacheModePos) {
          let dataDates = JSON.parse(datesArray);
          this.childComponents.getDatesArray = dataDates;
          this.childComponents.SELECTED_DATE = this.getCurrentDateNew(
            "DD-MM-YYYY"
          );
          this.GET_SHOWS();
        } else {
          PosService.getAllDates()
            .then((response) => {
              if (response) {
                let { data } = response;
                if (data.status && data.Records.length > 0) {
                  this.childComponents.getDatesArray = data.Records;
                  this.childComponents.SELECTED_DATE = this.getCurrentDateNew(
                    "DD-MM-YYYY"
                  );
                  this.GET_SHOWS();
                  window.localStorage.setItem(
                    "datesArray",
                    JSON.stringify(data.Records)
                  );
                } else {
                  this.$toasted.show(data.message || "Please try later");
                }
              }
            })
            .catch((err) => {
              this.$toasted.show(err.message || "Please try later");
            });
        }
      },
      GET_CACHE_KEY() {
        PosService.checkLocalCacheKey()
          .then((response) => {
            const { data } = response;
            if (data.status && data.key) {
              let cacheKey = window.localStorage.getItem("localCacheKey");
              if (data.key != cacheKey) {
                window.localStorage.setItem("localCacheKey", data.key);
                window.localStorage.removeItem("showDataCache");
                window.localStorage.removeItem("datesArray");
                window.localStorage.removeItem("fnb_items_array");
                window.localStorage.removeItem("fnb_categories");
                this.GET_SHOWS();
              }
            } else {
              window.localStorage.removeItem("showDataCache");
              window.localStorage.removeItem("datesArray");
              window.localStorage.removeItem("fnb_items_array");
              window.localStorage.removeItem("fnb_categories");
              this.GET_SHOWS();
            }
          })
          .catch((err) => {
            console.log("Error:", err);
            window.localStorage.removeItem("showDataCache");
            window.localStorage.removeItem("datesArray");
            window.localStorage.removeItem("fnb_items_array");
            window.localStorage.removeItem("fnb_categories");
            this.GET_SHOWS();
          });
      },
      GET_SHOWS() {
        let showDataCache = window.localStorage.getItem("showDataCache");
        if (
          showDataCache &&
          JSON.parse(showDataCache) &&
          this.cacheModePos &&
          this.childComponents.SELECTED_DATE ==
            this.getCurrentDateNew("DD-MM-YYYY") &&
          !this.selectedMovieLanguageFilter &&
          !this.selectedMovieFormatFilter &&
          !this.selectedMovieGenreFilter &&
          !this.search
        ) {
          this.SET_ALL_SHOWS(JSON.parse(showDataCache));
        } else {
          let payload = {
            selectedDate: this.childComponents.SELECTED_DATE,
            cinema_id: this.getCinemaId(),
            lang_id: this.selectedMovieLanguageFilter,
            format_id: this.selectedMovieFormatFilter,
            genre_id: this.selectedMovieGenreFilter,
            pos_user_id: this.getUserDetail("user_id"),
            search: this.search,
          };
          this.showLoading();

          PosService.getAllShows(payload)
            .then((response) => {
              if (response) {
                let { data } = response;
                if (data.status && data.Records.length > 0) {
                  this.SET_ALL_SHOWS(data);
                  if (
                    this.childComponents.SELECTED_DATE ==
                      this.getCurrentDateNew("DD-MM-YYYY") &&
                    !this.selectedMovieLanguageFilter &&
                    !this.selectedMovieFormatFilter &&
                    !this.selectedMovieGenreFilter &&
                    !this.search
                  ) {
                    window.localStorage.setItem(
                      "showDataCache",
                      JSON.stringify(data)
                    );
                  }
                } else {
                  this.visibleShowsLanguage = [];
                  this.visibleShowsScreens = [];
                  this.visibleShowsDates = [];
                  if (
                    data.hasOwnProperty("notAuthorized") &&
                    data.notAuthorized
                  ) {
                    this.$toasted.show(data.message || "Please try later");
                    window.localStorage.clear();
                    this.$router.replace({
                      path: "/",
                    });
                  }
                  // this.$toasted.show(data.message || "Please try later");
                }
              }
            })
            .catch((err) => {
              this.$toasted.show(err.message || "Please try later");
            })
            .finally(() => {
              this.hideLoading();
              this.$refs.selectFormat.hide();
            });
        }
      },
      validateShowData(show, timeZone) {
        let validate = true;
        if (show) {
          let currentDateTime =
            timeZone && timeZone["tz_name"]
              ? momentTimeZone()
                  .tz(timeZone["tz_name"])
                  .format("YYYY-MM-DD HH:mm")
              : moment().format("YYYY-MM-DD HH:mm");
          let showCuttoffTime = !isNaN(String(show["cine_cutoff_time_in_mins"]))
            ? parseInt(show["cine_cutoff_time_in_mins"])
            : 30;
          let showDate = moment(show["ss_actual_start_date"]).format(
            "YYYY-MM-DD"
          );
          let showTime = moment(show["ss_start_show_time"], "HH:mm").format(
            "HH:mm"
          );
          let showVisibleTill = moment(showDate + " " + showTime)
            .add(showCuttoffTime, "minutes")
            .format("YYYY-MM-DD HH:mm");

          if (moment(currentDateTime).isAfter(showVisibleTill)) {
            validate = false;
          } else {
            validate = true;
          }
          return validate;
        } else {
          return validate;
        }
      },
      searchMovieOffline() {
        let self = this;
        if (self.showResponse && Object.keys(self.showResponse).length) {
          let tempObj = _.cloneDeep(self.showResponse["Records"]);
          if (self.search && self.search.length > 0) {
            tempObj["Records"] = self.showResponse["Records"].filter((x) => {
              if (
                x.movie_title &&
                x.movie_title.toLowerCase().includes(self.search.toLowerCase())
              ) {
                return x;
              } else if (
                x.language_name &&
                x.language_name
                  .toLowerCase()
                  .includes(self.search.toLowerCase())
              ) {
                return x;
              } else if (
                x.screen_name &&
                x.screen_name.toLowerCase().includes(self.search.toLowerCase())
              ) {
                return x;
              } else if (
                x.movie_format &&
                x.movie_format.toLowerCase().includes(self.search.toLowerCase())
              ) {
                return x;
              }
            });
          } else {
            tempObj["Records"] = self.showResponse["Records"];
          }
          self.SET_ALL_SHOWS(tempObj, "search");
        } else {
          self.GET_SHOWS();
        }
      },
      SET_ALL_SHOWS(payload, type = "set") {
        let state = {
          userINFO: "",
          showTimes: "",
          filteredShowTimes: "",
        };
        if (type == "set") {
          this.showResponse = _.cloneDeep(payload);
        }
        state.userINFO = payload._result;
        let self = this;
        let timeZone = payload["timeZone"] || null;
        payload.Records = payload.Records.filter((_show) =>
          self.validateShowData(_show, timeZone)
        );
        if (payload != "filter") {
          state.showTimes = payload.Records;
          state.filteredShowTimes = payload.Records;
        }
        let showData_Date = groupBy(state.filteredShowTimes, "md_id");
        let DatestempArray = [];
        for (let key in showData_Date) {
          if (showData_Date.hasOwnProperty(key)) {
            DatestempArray.push(showData_Date[key]);
          }
        }

        // sorted by showtime
        this.visibleShowsDates = _.sortBy(DatestempArray, [
          (item) => item[0].ss_start_show_time,
        ]);
        //visibleShowsScreens
        let showData_Screen = groupBy(state.filteredShowTimes, "screen_id");
        let tempArray = [];
        for (let key in showData_Screen) {
          if (showData_Screen.hasOwnProperty(key)) {
            tempArray.push(showData_Screen[key]);
          }
        }
        let finalTempArray = [];
        tempArray.map((item, index) => {
          let tempArray1 = [];
          let newtempArray1 = groupBy(item, "md_id");

          for (let key in newtempArray1) {
            if (newtempArray1.hasOwnProperty(key)) {
              tempArray1.push(newtempArray1[key]);
            }
          }

          // sorted by showtime
          tempArray1 = _.sortBy(tempArray1, [
            (item) => item[0].ss_start_show_time,
          ]);
          finalTempArray.push(tempArray1);
        });
        finalTempArray = _.sortBy(finalTempArray, "screen_order");

        finalTempArray = finalTempArray.sort(function(a, b) {
          return a[0][0]["screen_order"] - b[0][0]["screen_order"];
        });

        console.log("finalTempArray", finalTempArray);

        this.visibleShowsScreens = finalTempArray;

        //visibleShowsLanguage
        let showData_language = groupBy(
          state.filteredShowTimes,
          "language_name"
        );
        let _tempArray = [];
        for (let key in showData_language) {
          if (showData_language.hasOwnProperty(key)) {
            _tempArray.push(showData_language[key]);
          }
        }
        let _finalTempArray = [];
        _tempArray.map((item, index) => {
          let _tempArray1 = [];
          let _newtempArray1 = groupBy(item, "md_id");

          for (let key in _newtempArray1) {
            if (_newtempArray1.hasOwnProperty(key)) {
              _tempArray1.push(_newtempArray1[key]);
            }
          }
          // sorted by showtime
          _tempArray1 = _.sortBy(_tempArray1, [
            (item) => item[0].ss_start_show_time,
          ]);
          _finalTempArray.push(_tempArray1);
        });
        // console.log('_finalTempArray :', _finalTempArray);
        this.visibleShowsLanguage = _finalTempArray;

        // this.$socket.emit("get_shows_list", this.visibleShowsDates);
        console.log("this.$ipcRenderer", this.$ipcRenderer);

        if (this.$ipcRenderer) {
          this.$ipcRenderer.send("GET_ALL_SHOWS_PAGE", this.visibleShowsDates);
        } else {
          console.log("Not running inside Electron");
        }
      },
      getSortArrayHere: function(data) {
        return _.sortBy(data, ["ss_actual_start_date_time"]);
      },
      OnChangeDate(dateVal) {
        this.childComponents.SELECTED_DATE = dateVal;
        this.GET_SHOWS();
      },
      onCheckAuthentication(response) {
        const { valid, name, user_id } = response;
        if (valid) {
          if (name == "privateEventAuth") {
            this.noAuth = true;
            this.$bvModal.hide("privateEventAuth");
            const params1 = this.tempSelectedShowTime['params1'];
            const params2 = this.tempSelectedShowTime['params2'];
            this.onClickShow(params1, null, params2);
          }
        }
      },
      timeSinceShowElapsed(showTime, showDate, cutoffTime) {
        let movie_showtime = moment(
          moment(showDate).format("YYYY-MM-DD") + " " + showTime,
          "YYYY-MM-DD HH:mm"
        );
        var show_date_with_cutoff =
          movie_showtime.valueOf() + cutoffTime * 60 * 1000;
        var currentTime = moment().valueOf();
        if (currentTime >= show_date_with_cutoff) {
          return false;
        } else {
          return true;
        }
      },
      onChangeTab: function(event) {},
      onChangeFilter: function(event, name) {
        this.selectedFilterName = name;
      },

      async onClickMovieModal(movie_id, md_id) {
        let payload = {
          movie_id,
          md_id,
        };
        let { data } = await PosService.getMovieDetails(payload);
        if (data && data.status) {
          this.movieDetails = data.Records[0];
          if (this.movieDetails["MovieContent"].length > 0) {
            this.selectedContentLang = {
              lang_id: this.movieDetails["MovieContent"][0].lang_id,
              lang_name: this.movieDetails["MovieContent"][0].lang_name,
            };
          }
        } else {
        }
      },
      applyFilters() {
        this.GET_SHOWS();
      },
      onCloseModal: function(modalName) {
        this.$refs[modalName].hide();
      },
      onClickCall: async function(name) {
        if (name == "Filter") {
          this.showLoading();

          Promise.all([
            this.fetchMovieFormats(),
            this.fetchMovieLanguages(),
            this.fetchMovieGenre(),
          ]).then((response) => {
            setTimeout(() => {
              this.$refs.selectFormat.show();
              this.hideLoading();
            }, 1000);
          });
        }
      },
    },
  };
</script>
<style>

.private_event_btn {
  background: goldenrod;
}
  .movie-list {
    /* display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  height: calc(100vh - 250px) !important; */
    /* gap: 15px; */
    /* display: flex;
  flex-direction: row; */
    place-content: flex-start;
    overflow-y: auto;
    height: calc(100vh - 250px) !important;
  }

  .movie-list-single {
    display: block;
    height: calc(100vh - 250px) !important;
  }

  .formatBox {
    font-size: 9px;
    /* line-height: 1;
    font-size: 10px;
    padding: 0 2px;
    color: #969696;
    border-radius: 3px;
    background-color: #fff;
    border: 1px solid #969696; */
  }

  .movie-card-horizontal-single {
    display: flex;
    align-items: flex-start;
    background: #fff;
    border-radius: 12px;
    /* overflow: hidden; */
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 10px;
    min-height: 180px;
    height: fit-content;
    width: 100%;
    /* margin-right: 15px;
  margin-bottom: 15px; */
  }

  .movie-card-horizontal {
    display: flex;
    align-items: flex-start;
    background: #fff;
    border-radius: 12px;
    /* overflow: hidden; */
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 10px;
    min-height: 180px;
    height: fit-content;
    width: 100%;
    /* width: 24%; */
    /* margin-right: 15px;
  margin-bottom: 15px; */
  }

  /*
.movie-card-horizontal {
  display: flex;
  align-items: flex-start;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  max-width: 500px;
  padding: 10px;
  gap: 15px;
  max-height: 180px;
  margin-right: 20px;
} */

  .poster img {
    width: 113px;
    height: 160px;
    object-fit: cover;
    border-radius: 8px;
  }

  .poster {
    margin-right: 10px;
  }

  .details {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .title {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 5px;
  }

  .meta {
    font-size: 13px;
    color: #555;
    display: flex;
    gap: 6px;
    align-items: center;
    margin-bottom: 10px;
  }

  .badge {
    background: var(--blue);
    color: white;
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 4px;
  }

  .duration {
    color: var(--blue);
    font-weight: 500;
    font-size: 11px;
  }

  .showtimes {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .showtimes span {
    border: 1px solid #4caf50;
    color: #4caf50;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 13px;
  }

  .listed-movie-time-list li.disabled {
    border-color: #d3d3d3;
    color: #fff;
    background: #d3d3d3;
    pointer-events: none;
    cursor: default;
  }

  .btn_min_width_190 {
    min-width: 190px;
  }

  .circle {
    border-radius: 50%;
    width: 1px;
    height: 15px;
    padding: 3px 4px;
    background: #fff;
    border: 1px solid #000;
    color: #000;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
  }

  .al_dropdown button {
    font-size: 0.84rem;
    line-height: 1;
  }

  .avail {
    color: green;
  }

  #listed-movie-synopsis .btn-modal-close {
    top: -10px !important;
    right: -21px !important;
  }

  .no-padding {
    padding: 0px !important;
  }

  .search-input {
    /* top: 2.5px; */
    /* top: 0; */
    /* height: 55px; */
    /* font-size: 14px; */
    /* position: absolute; */
    /* width: 25%; */
    /*flex: 0 0 35%;*/
    min-width: 200px;
    /* left: 527px; */
  }

  .search-input .form-control {
    /* height: 45px; */
    height: 45px;
    /* border-radius: 20px; */
    border-radius: 50rem;
    font-size: 14px;
    width: 100%;
  }

  /* .pos-menus-hidden {
  top: -156px;
  height: 167px;
} */

  /* .pos-modal-close {
  top: -11px !important;
    right: -30px !important;
} */

  .viewSwap {
    cursor: pointer;
    text-decoration: underline;
  }
</style>
<style scoped>
  /*@media (min-width: 992px) {*/

  /* .seat_select_modal .modal-lg{*/
  /*  max-width: 1030px;*/
  /*  background-color: white;*/
  /*  } */

  /*}*/

  .w-150 {
    min-width: 150px;
  }

  .seat-type {
    padding: 1rem;
    min-width: 200px;
    height: 115px;
    font-weight: bold;
  }

  #showRateCardPrice .seat-type {
    width: 280px !important;
  }

  .seat-type.gold {
    background-color: #fcf4d9;
    color: #f2c94c;
  }

  .seat-type.silver {
    background-color: #efefef;
    color: #a8a8a8;
  }

  .seat-type .st-name {
    font-weight: bold;
    font-size: 2.5rem;
    border-bottom: 1px solid #bfbfbf;
    line-height: 1;
    margin-bottom: 0.25rem;
    word-break: break-all;
  }

  #showRateCardPrice .category {
    width: 240px !important;
  }

  #showRateCardPrice .category .category-name {
    word-break: break-all;
  }

  .category {
    display: flex;
    flex-direction: column;
    width: 180px;
    height: 160px;
    background-color: #efefef;
    color: black;
    text-align: center;
    margin: 1rem;
    border-radius: 0.5rem;
  }

  .category.disabled {
    background-color: #f9f9f9;
    color: #999999;
  }

  .category.disabled .mod-btn {
    background-color: #afc8ed;
  }

  .category .category-name {
    font-size: 1.5rem;
    font-weight: 500;
    height: 53px;
    text-align: center;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .category .category-price {
    font-size: 1.5rem;
    font-weight: 500;
    height: 53px;
    text-align: center;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .category .category-seats {
    font-weight: bold;
    font-size: 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-top: 1px solid #bfbfbf;
    padding: 0.25rem;
    width: 100%;
    color: black;
    user-select: none;
  }

  .category .category-seats .mod-btn {
    font-weight: bold;
    font-size: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    color: white;
    background-color: var(--blue);
    height: 40px;
    width: 40px;
    border-radius: 0.25rem;
    cursor: pointer;
    transition: all 0.4s;
  }

  .category .category-seats .mod-btn:hover {
    color: var(--blue);
    background-color: white;
  }

  .category .category-seats .mod-btn:active,
  .category .category-seats .mod-btn.active {
    transform: scale(0.8);
  }

  .category .category-seats .mod-btn.disabled,
  .btn-submit-disabled {
    background-color: lightgrey;
    pointer-events: none;
  }

  .fl.btn-blue {
    font-size: 20px !important;
    padding: 1.5rem 2rem;
  }

  .currency-symbol {
    position: absolute;
    top: 50%;
    right: 10px;
    font-size: 12px;
    transform: translateY(-50%);
  }

  .InputAmount {
    padding-right: 3rem !important;
  }

  .noFnbItem {
    font-size: 13px;
  }

  .no-fnb-btn {
    background-color: white !important;
    color: red !important;
    border-color: red !important;
  }

  .status-dot {
    display: inline-block;
    margin-left: 6px;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: var(--success);
  }

  .nfs-17 {
    font-size: 17px !important;
  }

  .voucher-box {
    height: 114px;
    margin: 22px;
    width: 40px;
    background: lightgray;
    border-radius: 10px;
  }

  .voucher_btn {
    background-color: var(--blue);
    color: white;
    border: 1px solid transparent;
    border-radius: 12px;
    /* padding: 16px; */
    padding: 8px;
    text-align: center;
    /* margin-bottom: 24px; */
    margin-bottom: 16px;
    line-height: 1.2;
    cursor: pointer;
    transition: border-color 0.5s, transform 0.5s, background-color 0.5s,
      color 0.5s;
    display: flex;
    flex-flow: column nowrap;
    /* height: 125px; */
    height: 80px;
    justify-content: center;
    align-items: center;
  }

  .voucher_btn:active {
    transform: scale(0.9);
  }

  .voucher_btn:active,
  .voucher_btn.active,
  .voucher_btn:hover {
    background-color: white;
    box-shadow: 0px 2px 6px -1px;
    color: var(--blue);
    border-color: var(--blue);
  }

  .giftcard_input {
    min-height: 175px;
  }

  .voucher_btn.inactive {
    /* background-color: grey;
  cursor: default;
  pointer-events: none;
  opacity: 0.2; */
    background-color: lightgray;
    cursor: default;
    pointer-events: none;
    opacity: 0.3;
    color: black;
  }

  .voucher_btn .voucher_btn__name > p {
    font-size: 18px;
    font-weight: bold;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    /* -webkit-line-clamp: 2; */
    -webkit-line-clamp: 1;
    margin-bottom: 0;
  }

  .voucher_btn .voucher_btn__screen > p {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .voucher_btn .voucher_btn__time > p {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .voucher_btn .voucher_btn__details {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .voucher_btn .voucher_btn__name + .voucher_btn__details {
    margin-top: 4px;
  }

  .voucher_btn .voucher_btn__details > div:nth-last-child(2) {
    max-width: 65%;
  }

  .voucher_btn .voucher_btn__details > div:nth-child(2) {
    margin-left: 12px;
  }

  .voucher_btn_row > article.col-6:nth-child(odd) {
    padding-right: 8px;
  }

  .voucher_btn_row > article.col-6:nth-child(even) {
    padding-right: 8px;
  }

  .pm_disbaled {
    opacity: 0.5;
    pointer-events: none;
  }

  .pos_booking_input_material .input-material input:focus + label,
  .pos_booking_input_material
    .input-material
    input:not(:placeholder-shown)
    + label,
  .pos_booking_input_material
    .input-material
    textarea:not(:placeholder-shown)
    + label,
  .pos_booking_input_material
    .input-material-textarea
    textarea:not(:placeholder-shown)
    + label,
  .pos_booking_input_material .input-material input.is_active + label {
    left: 36px;
    top: -5px;
    background-color: #fff;
    color: var(--blue);
    font-size: 12px;
  }

  .pos_booking_input_material .input-material input.is_active {
    color: #495057;
    background-color: #fff;
    /* border-color: #80bdff; */
    outline: 0;
    /* -webkit-box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%); */
    /* box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%); */
  }

  .pos_booking_input_material .input-material input + label,
  .input-material textarea + label,
  .input-material-textarea textarea + label {
    top: 18px;
    left: 36px;
  }

  .word-break {
    word-break: break-all;
  }

  @media screen and (min-width: 578px) and (max-width: 768px) {
    .img_height {
      height: 20vh;
    }
  }

  @media screen and (min-width: 769px) and (max-width: 991px) {
    .img_height {
      height: 20vh;
    }
  }

  @media screen and (min-width: 992px) and (max-width: 1200px) {
    .img_height {
      height: 21vh;
    }
  }

  @media screen and (min-width: 1201px) and (max-width: 1400px) {
    .img_height {
      height: 20vh;
    }
  }

  @media screen and (min-width: 1401px) and (max-width: 1600px) {
    .img_height {
      height: 20vh;
    }
  }

  @media (max-width: 1200px) {
    .pos-movie-listing-wrapper .btn-blue-lg {
      height: 40px !important;
      font-size: 12px;
    }

    .search-input .form-control {
      height: 40px;
    }
  }

  .pos-datepicker {
    zoom: 0.75 !important;
    font-size: 25px !important;
    font-weight: bold !important;
  }

  .pos-datepicker .btn-modal-close {
    width: 40px;
    border: none;
    height: 40px;
    display: flex;
    line-height: 0;
    font-size: 52px;
    align-items: center;
    justify-content: center;
    background-color: white !important;
    top: -17px !important;
    right: -31px !important;
  }
</style>
</style>



// WEBPACK FOOTER //
// src/components/posBooking.vue